import { DesignSystemViewer } from './DesignSystemViewer'

export function DesignSystemReference(): JSX.Element {
  return (
    <DesignSystemViewer
      title="Referencia de componentes"
      description="Todos los componentes del sistema de diseño — botones, inputs, tarjetas, bloques de protocolo y más."
      src="/design-system/reference.html"
    />
  )
}
